
<div class="bulk-tag-add-container">
  <h4>Search your tag to add</h4>
  <mat-dialog-content class="tag-add-container">
    <app-tag-search [query]="searchQuery$ | async" (search)="search($event)" [placeholder]="'Add a tag'"></app-tag-search>
    <div #showBulkTagResults *ngIf="showResults" class="search-results">
        <a *ngFor="let tag of tags$ | async" class="search-result" (click)="selectedTag(tag)">{{tag.id}}</a>
    </div>
    <img *ngIf="loading" src="/assets/img/logo-preloader.png" alt="..." class="logo-loading animate-flicker" />
  </mat-dialog-content>
</div>
